import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Moment from 'react-moment';

import Hor_header from "../header/hor_header";
import Ver_header from "../header/ver_header";
import Footer from "../footer/footer";

import { API_URL } from "../constant";
import Loader from "./loading";

import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "datatables.net-buttons/js/dataTables.buttons";
import "datatables.net-buttons/js/buttons.colVis";
import "datatables.net-buttons/js/buttons.flash";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/buttons.print";
import "datatables.net-responsive";

import $ from 'jquery';


function BenArchive() {

  const navigat = useNavigate();

  const [userData, setUserData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);


  $('#example').DataTable().destroy();

  $(document).ready(function () {

    $('#example').DataTable({
      destroy: true,
      'aoColumnDefs': [{
        'bSortable': false,
        'aTargets': ['nosort']
      }],
      dom: 'Bfrtip',
      buttons: ['copy', 'csv', 'excel', 'pdf', 'print']
      //  responsive: true
    });
  });
  /*********************get parameter from url*********************************** */
  //const params = useParams();

  /******************************************************** */

  useEffect(() => {
    document.title = "Transfer Beneficiary Archives";
    getAllBenArchiveData();
  }, [1]
  );
  /************Get all state data********************** */
  let getAllBenArchiveData = async () => {
  
    const res = await axios.post(API_URL + 'admin/benificaryTransfer_archive')
      .then(ress => {
       
        setUserData(ress.data.Rdata);
        setIsLoading(false);
      });
    
  }




  return (

    <div className="container-scroller">

      <Hor_header />

      <div className="container-fluid page-body-wrapper">

        <Ver_header />

        <div className="main-panel">
          {isLoading ? (<Loader />) : (
            <>
              <div className="content-wrapper">
                <div className="row">


                  <div className="col-lg-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body">
                        <h4 className="card-title">Transferred Beneficiary Data</h4>

                        <div className="table-responsive pt-3">
                          {/* <table className="table table-bordered display responsive nowrap" id="example"> */}
                          <table className="table table-bordered display  nowrap" id="example">
                            <thead>
                              <tr>

                                <th>Transfer From </th>
                                <th>Mobile </th>
                                <th>Transfer To </th>
                                <th>Mobile</th>
                                <th>Beneficiary Name </th>
                                <th>Mobile</th>
                                <th>Transfer Date</th>
                              </tr>
                            </thead>
                            <tbody>

                              {userData.map((udata, index) => (
                                <tr key={index}>
                                  <td> {udata.tran_from}</td>
                                  <td> {udata.mob_from}</td>
                                  <td> {udata.tran_to}</td>
                                  <td> {udata.mob_to}</td>
                                  <td> {udata.pat_name}</td>
                                  <td> {udata.mob_pat}</td>
                                  <td><Moment format="DD-MM-YYYY">{udata.transfer_date}</Moment></td>

                                </tr>
                              )
                              )}

                            </tbody>
                          </table>
                        </div>

                      </div>
                    </div>
                  </div>


                </div>
              </div>

              <Footer />
            </>
          )}
        </div>

      </div>

    </div>);
}

export default BenArchive;